export default __webpack_public_path__ + "static/media/hre-group.be1c0134.svg";